export const VisibilityType = {
  READ_WRITE: 'READ_WRITE',
  READ_ONLY: 'READ_ONLY',
  HIDDEN: 'HIDDEN',
} as const;

export type VisibilityMap = {
  [fieldApiId: string]: keyof typeof VisibilityType;
};

export type SetFieldsVisibility = (
  arg: VisibilityMap | ((currentVisibilityMap: VisibilityMap) => VisibilityMap)
) => void;

/**
 *@deprecated
 */
export type VisibilityTypes = keyof typeof VisibilityType;
